import React from 'react'
import {
  List,
  DatagridConfigurable,
  TextField,
  DateField,
  FunctionField,
  ShowButton,
  FilterButton,
  ExportButton,
  useRecordContext,
} from 'react-admin';
import { Chip } from '@mui/material';
import NestedReferenceField from '../../components/NestedReferenceField';

const AcceptationField = () => {
  const record = useRecordContext();
  if (!record) return null;
  if (record.acceptation_date) {
    return <Chip label="Accepted" color="success" size="small" />;
  }
  return <Chip label="Pending" color="warning" size="small" />;
};

const UserInviteList = (props) => {
  const actions = (
    <>
      <FilterButton />
      <ExportButton />
    </>
  );

  return (
    <List {...props} perPage={50} sort={{ field: 'id', order: 'DESC' }} actions={actions}>
      <DatagridConfigurable bulkActionButtons={false}>
        <TextField source="id" label="ID" />
        <NestedReferenceField source="inviting_user" labelField="email" resource="users" label="Invited by" />
        <NestedReferenceField source="invited_user" labelField="email" resource="users" label="Invited user" />
        <FunctionField label="Status" render={() => <AcceptationField />} sortable={false} />
        <DateField source="acceptation_date" label="Accepted at" showTime />
        <DateField source="creation_date" label="Sent at" showTime />
        <ShowButton />
      </DatagridConfigurable>
    </List>
  );
};

export default UserInviteList;
